<template>
  <div v-if="iconFallback && isError" class="relative flex items-center justify-center">
    <i class="text-xl" :class="iconFallback" />
  </div>
  <img v-else ref="img" :src="url" @error="checkForFallback()" @load="onloadMethod" />
</template>

<script>
import { config } from '@/utils/config'

export default {
  props: {
    src: {
      required: true
    },
    fallback: {
      required: false,
      default: undefined
    },
    iconFallback: String
  },
  data() {
    return {
      isError: false
    }
  },
  computed: {
    url() {
      if (this.src.indexOf('//') !== -1) {
        return this.src
      }
      return config.image_base_url + this.src
    }
  },
  methods: {
    checkForFallback() {
      this.isError = true
      if (this.fallback) {
        this.$refs.img.src = this.fallback
      }
    },
    onloadMethod(event) {
      this.$emit('load', event)
    }
  }
}
</script>
